( function ($) {

    $(document).ready(function () {
        collapsibleContent();
    });

function collapsibleContent() {
    var button = $('.section_expandable_contents .collapsibleContent_btn'),
        mClass = 'open',
        mClass2 = 'content_is_visible';
    button.click(function () {

        var btn = $(this),
            parent = btn.parent(),
            wrap = parent.find('.collapsibleContent');
        if (!btn.hasClass(mClass)) {
            var height = wrap.find('.internal_wrap').outerHeight(true);
            wrap.css({
                'height': height
            });
            btn.addClass(mClass);
            $(parent).addClass(mClass2);

        } else {
            wrap.css({
                'height': 0,
                'overflow': 'hidden',
            });
            btn.removeClass(mClass);
            $(parent).removeClass(mClass2);

        }
    });
}

}(jQuery) );